import Transition from "react-transition-group/Transition";
import { useCropperStore } from "../store/cropper/cropper-store";

const duration = 300;
const timeout = 500;

const defaultStyle = {
  transition: `opacity ${duration}ms ease-in-out`,
  opacity: 0.5,
  width: '100%',
};

const transitionStyles = {
  entering: { opacity: 1, pointerEvents: 'initial' },
  entered:  { opacity: 1, pointerEvents: 'initial' },
  exiting:  { opacity: 0.5, pointerEvents: 'none' },
  exited:  { opacity: 0.5, pointerEvents: 'none' },
};

function LoadingBox({ children }) {
  const ready = useCropperStore(s => s.isCropperReady());
  return (
    <Transition
      timeout={duration}
      in={ready}
    >
      {state => (
        <div style={{
          ...defaultStyle,
          ...transitionStyles[state],
          transitionDelay: ready ? `${timeout}ms` : '0ms'
        }}>
          {children}
        </div>
      )}
    </Transition>
  );
};

export default LoadingBox;